export enum AutoAssignMode {
  leastPending =  0,
  evenly =        1
}